import { Routes } from '@angular/router';
import {
    LoginComponent,
    VehicleComponent,
    VehicleActivityComponent,
    LineComponent,
    VehicleWarningComponent,
    VehicleHistoryComponent,
    RegisterDamageRiskComponent
} from './app/components';
import { MapComponent } from './app/feature/map/map.component';
import { CanCloseBladeGuard } from './app/modules/blades/guards/can-close-blade.guard';
import { MsalGuard } from '@azure/msal-angular';
import { HasAccessGuard } from './app/modules/core/guards/has-access.guard';
import { CreateTrafficDeviationOverviewComponent } from '@components/selection-overview';
import { TripsComponent } from '@components/traffic-deviations/components/searches/components/search-route-and-trip/components/trips/trips.component';
import { SelectedLineStopListComponent } from '@components/traffic-deviations/components/searches/components/search-stop/components/selected-line-stop-list/selected-line-stop-list.component';
import { SelectedCallComponent } from '@components/traffic-deviations/components/selected-call/selected-call.component';
import { SelectedVehicleComponent } from '@components/traffic-deviations/components/selected-vehicle/selected-vehicle.component';
import { HasTaAccessGuard } from '@modules/core/guards/has-ta-access';
import { BlankComponent } from '@components/blank/blank.component';

export const routes: Routes = [
    { path: '', component: MapComponent, canActivate: [MsalGuard],
    children: [
        {
            path: 'vehicle/:inventoryNumber',
            component: VehicleComponent,
            canActivate: [MsalGuard],
            outlet: 'outlet-right0'
        },
        {
            path: 'line/:lineId',
            component: LineComponent,
            canActivate: [MsalGuard],
            outlet: 'outlet-right0'
        },
        {
            path: 'vehicle/:inventoryNumber',
            component: VehicleComponent,
            canActivate: [MsalGuard],
            outlet: 'outlet-right1'
        },
        {
            path: 'activity/:vehicleActivityId',
            component: VehicleActivityComponent,
            canActivate: [MsalGuard],
            outlet: 'outlet-right1'
        },
        {
            path: 'activity/:vehicleActivityId',
            component: VehicleActivityComponent,
            canActivate: [MsalGuard],
            outlet: 'outlet-right2'
        },
        {
            path: 'connection/:inventoryNumber',
            component: VehicleComponent,
            canActivate: [MsalGuard],
            outlet: 'outlet-right2'
        },
        {
            path: 'history',
            component: VehicleHistoryComponent,
            canActivate: [MsalGuard],
            outlet: 'outlet0'
        },
        {
            path: 'register-damage-risk', component: RegisterDamageRiskComponent,
            canDeactivate: [CanCloseBladeGuard],
            canActivate: [MsalGuard, HasAccessGuard],
            outlet: 'outlet0'
        },
        {
            path: 'vehicleWarning/:warningType',
            component: VehicleWarningComponent,
            canActivate: [MsalGuard],
            outlet: 'outlet0'
        },
        {
            path: 'traffic-deviation/:id',
            component: CreateTrafficDeviationOverviewComponent,
            canActivate: [MsalGuard, HasTaAccessGuard()],
            outlet: 'outlet0'
        },
        {
            path: 'trips/:lineId',
            component: TripsComponent,
            canActivate: [MsalGuard, HasTaAccessGuard()],
            outlet: 'outlet0'
        },
        {
            path: 'selected-line/stop-areas',
            component: SelectedLineStopListComponent,
            canActivate: [MsalGuard, HasTaAccessGuard()],
            outlet: 'outlet1'
        },
        {
            path: 'selected-line/stop-places', 
            component: SelectedLineStopListComponent,
            canActivate: [MsalGuard, HasTaAccessGuard()],
            outlet: 'outlet1'
        },
        {
            path: 'selected-call/:scope',
            component: SelectedCallComponent,
            canActivate: [MsalGuard, HasTaAccessGuard()],
            outlet: 'outlet1'
        },
        {
            path: 'selected-vehicle',
            component: SelectedVehicleComponent,
            canActivate: [MsalGuard, HasTaAccessGuard()],
            outlet: 'outlet1'
        },
        {
            path: 'activity/:vehicleActivityId',
            component: VehicleActivityComponent,
            canActivate: [MsalGuard],
            outlet: 'outlet2'
        },
    ] },
    {
        path: 'login',
        component: LoginComponent
    },
    { path: 'blank', component: BlankComponent },
    { path: '**', redirectTo: '' }
];